import { z } from 'zod';

/**
 * Wave 4 enums: frozen scorecards (SPEC §7.8, PLAN §3.3 sec. 11.9, D-830 ff.). The CHECK
 * constraints of `scorecard_snapshots` and `scorecard_snapshot_lines`
 * (packages/db/src/schema/scorecards.ts) are built from these lists.
 */

/**
 * `scorecard_snapshots.status`: `provisional` when the month freezes, `final` when it closes (final
 * rows are immutable), `superseded` when a rebuild with different inputs wrote a new revision.
 */
export const SCORECARD_SNAPSHOT_STATUSES = ['provisional', 'final', 'superseded'] as const;
export type ScorecardSnapshotStatus = (typeof SCORECARD_SNAPSHOT_STATUSES)[number];
export const scorecardSnapshotStatusSchema = z.enum(SCORECARD_SNAPSHOT_STATUSES);

/** `scorecard_snapshot_lines.status` (PLAN §3.3 sec. 13.3). */
export const SCORECARD_LINE_STATUSES = [
  'on_track',
  'at_risk',
  'off_track',
  'no_data',
  'no_target',
] as const;
export type ScorecardLineStatus = (typeof SCORECARD_LINE_STATUSES)[number];
export const scorecardLineStatusSchema = z.enum(SCORECARD_LINE_STATUSES);
